import { render, staticRenderFns } from "./Navigator.vue?vue&type=template&id=a43dbcba&lang=pug&"
import script from "./Navigator.vue?vue&type=script&lang=js&"
export * from "./Navigator.vue?vue&type=script&lang=js&"
import style0 from "./Navigator.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a43dbcba')) {
      api.createRecord('a43dbcba', component.options)
    } else {
      api.reload('a43dbcba', component.options)
    }
    module.hot.accept("./Navigator.vue?vue&type=template&id=a43dbcba&lang=pug&", function () {
      api.rerender('a43dbcba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/Navigator.vue"
export default component.exports